import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RegisterValidationComponent } from './register-validation.component';

@NgModule({
  imports: [CommonModule],
  declarations: [RegisterValidationComponent]
})
export class ValidateModule {}
